<template>
  <div class="row">
    <aside class="col-md-3 col-sm-12 cus-sidebar">
        <ResourceSidebar />
    </aside>
    <div id="content" class="col-md-9 col-sm-12">
      <div class="material-box bg-white">
        <div class="row content-row">
          <div class="col-md-12 top-title">
            <h3 class="ml-2">Custom Forms</h3>
          </div>
          <div class="col-md-12">
            <div class="p-b-10"> 
                <div class="row">
                  <div class="col-md-12 box-detail">
                    <p>The following forms are provided to allow you to make changes that are specific to your practice.</p>
                    <p>These forms are in Microsoft Word format.  In order to modify these documents, you must have Microsoft Word installed.</p>
                    <h5 class="red text-center m-t-30">These forms are for the exclusive use of your practice and may not be distributed or shared with others.</h5>
                  </div>
                  <div class="col-md-12 top-title m-t-20">
                    <h3 class="ml-2">Forms:</h3>
                  </div>
                  <div class="content-colm" style="width: 100%;">
                    <div class="col-md-12 row">
                      <div class="col-md-12">
                        <div class="material-list video">
                       
                   
                      <ul>
                          <li v-for="(custom, index) in customForms" :key="index">
                            <!-- <i class="fa fa-chevron-right" style="color: #305397;"></i>  -->
                              <span class="ml-2" :id="`popover-target${index}${index}`">
                                {{custom.DocName}}
                              </span>&nbsp;&nbsp;({{'Module ' + custom.DocModule}} - {{'Week ' + custom.DocWeek}})
                              <b-popover :target="`popover-target${index}${index}`" triggers="hover">
                                <template #default>
                                 <a  @click.prevent="downloadFile(custom.DocModule,custom.CustomFormLocation, custom.DocName)"
                                    class="btn blue-btn">
                                    <span class="glyphicon glyphicon-cloud-download"></span>
                                    Download
                                </a>
                                </template>
                              </b-popover>
                          </li>
                        </ul>
                      </div>
                    </div>
                 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end page-header --> 
    </div>
  
  </div>
  
  </template>
  
  <script>
  
  // import ModuleBox from './components/ModuleBox.vue';
  import ResourceSidebar from './components/ResourceSidebar.vue';
  import userAPI from "../userApi";
  export default {
    components: { ResourceSidebar },
      name: "Custom_form",
      data() {
          return {
              id: "",
              customForms:[],
          }
      },
      methods: {
        getResourcesDoc() {
              userAPI.getResourcesDoc(res => {
                  this.customForms = res.data.data;
                  console.log('tag', this.customForms)
              }, err => {
                  console.log(err);
              })
          },
  downloadFile(DocModule,location,name) {
            try {
            userAPI.downloadPdf({path:window.location.hostname == '202.141.226.195' ? 'SampleCustomForm.docx' : location,Moduleid:DocModule },res=>{

                const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name+".docx"); // Set the desired file name and extension
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
            });

            } catch (error) {
                console.error('Error downloading file:', error);
            }
        },
      },
      mounted() {
        this.getResourcesDoc();
      },
    }
  </script>
  